<template>
    <v-container grid-list-xs>
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">Eleos</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-container grid-list-xs fluid>
                    <v-row class="mx-3" justify="left">
                        <v-col cols="4">
                            <v-combobox
                                prepend-icon="mdi-refresh"
                                @click:prepend="getShifts()"
                                v-model="header"
                                :items="shift_headers"
                                :item-text="'ShiftDate'"
                                :item-value="'ShiftId'"
                                label="Select Shift"
                                class="scroller"
                                auto-select-first
                                dense
                                hide-details
                                @change="getShifts()"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-card
                        v-for="(shift, idx) in dispatch"
                        v-bind:key="'Dsp' + idx"
                    >
                        <v-toolbar color="primary" dense dark>
                            <div
                                style="display: flex;align-items: center;width: 100%;gap: 25px;padding-right: 20px;"
                            >
                                <div>
                                    <v-icon v-if="shift.Finalize == 1"
                                        >mdi-shield-lock</v-icon
                                    >
                                    <v-icon v-else
                                        >mdi-shield-lock-open-outline</v-icon
                                    >
                                </div>
                                <p class="shiftText">{{ shift.Driver }}</p>
                                <p class="shiftText">{{ shift.Truck }}</p>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <p
                                            class="shiftText"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            {{ shift.Trailer }}
                                        </p>
                                    </template>
                                    <span class="shiftText"
                                        >{{
                                            shift.SpecificProduct == null
                                                ? 'Specific Product: not apply'
                                                : 'Specific Product: ' +
                                                  shift.SpecificProduct
                                        }}
                                    </span>
                                </v-tooltip>
                                <p class="shiftText">{{ shift.Yard }}</p>
                            </div>
                        </v-toolbar>
                        <v-container grid-list-xs>
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th>OrderID</th>
                                        <th>OrderStatus</th>
                                        <th>L1</th>
                                        <th>L2</th>
                                        <th>Terminal</th>
                                        <th colspan="3">Station</th>
                                        <th>City</th>
                                    </tr>
                                </thead>
                                <tbody
                                    v-for="(ords, i) in shift.orders"
                                    v-bind:key="'ords' + i"
                                >
                                    <tr>
                                        <td>{{ ords.OrderID }}</td>
                                        <td>{{ ords.OrderStatus }}</td>
                                        <td>{{ ords.LoadNum }}</td>
                                        <td>{{ ords.LoadNumOrd }}</td>
                                        <td>{{ ords.TerminalName }}</td>
                                        <td colspan="3">{{ ords.Station }}</td>
                                        <td>{{ ords.City }}</td>
                                    </tr>
                                    <tr>
                                        <th
                                            style="background: #fff;"
                                            colspan="5"
                                        ></th>
                                        <th class="text-center">Product</th>
                                        <th class="text-center">
                                            Dispatch Qty
                                        </th>
                                        <th class="text-center">Gross Qty</th>
                                        <th class="text-center">Net Qty</th>
                                    </tr>
                                    <tr
                                        v-for="(prd,
                                        index) in ords.order_details"
                                        v-bind:key="'prd' + index"
                                    >
                                        <td
                                            style="background: #fff;"
                                            colspan="5"
                                        ></td>
                                        <td
                                            style="background: #fff;"
                                            class="text-center"
                                        >
                                            {{ prd.Product }}
                                        </td>
                                        <td
                                            style="background: #fff;"
                                            class="text-center"
                                        >
                                            {{ prd.DispatchedQuantity }}
                                        </td>
                                        <td
                                            style="background: #fff;color:red;"
                                            class="text-center"
                                            v-if="
                                                prd.DiffGross < 0.05 &&
                                                    prd.DiffGross > 0
                                            "
                                        >
                                            {{ prd.GrossQuantity }}
                                        </td>
                                        <td
                                            style="background: #fff;"
                                            class="text-center"
                                            v-else
                                        >
                                            {{ prd.GrossQuantity }}
                                        </td>
                                        <td
                                            style="background: #fff;color:red;"
                                            class="text-center"
                                            v-if="
                                                prd.DiffNet < 0.05 &&
                                                    prd.DiffNet > 0
                                            "
                                        >
                                            {{ prd.NetQuantity }}
                                        </td>
                                        <td
                                            style="background: #fff;"
                                            class="text-center"
                                            v-else
                                        >
                                            {{ prd.NetQuantity }}
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-container>
                    </v-card>
                </v-container>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            dispatch: [],
            shift_headers: [],
            header: []
        };
    },
    async mounted() {
        this.loadShiftHeaders();
    },
    methods: {
        loadShiftHeaders: function() {
            this.$store.state.isLoading = true;
            axios
                .get('shift-header/dates/15')
                .then(response => {
                    this.shift_headers = response.data.data;
                    console.log(this.shift_headers);
                    // this.chargeShift();
                    this.loadCurrentShift(this.shift_headers);
                })
                .catch(function(error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        getShifts: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('shift-detail/header/' + this.header.ShiftId)
                .then(response => {
                    this.dispatch = response.data;
                    console.log(this.dispatch);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        }
    }
};
</script>
